import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Layout } from '@/components/layout/Layout';
import { Header } from '@/components/layout/header/Header';
import { ReferralHero } from '@/components/referral/ReferralHero';
import { ReferralBenefits } from '@/components/referral/ReferralBenefits';
import { ReferralSteps } from '@/components/referral/ReferralSteps';
import { ReferralAudience } from '@/components/referral/ReferralAudience';
import { ReferralSimulator } from '@/components/referral/ReferralSimulator';
import { ReferralFAQ } from '@/components/referral/ReferralFAQ';
import { ReferralCTA } from '@/components/referral/ReferralCTA';

export default function ReferralProgram() {
  useLanguage();
  return (
    <Layout fixedSidebar={true}>
      <div className="flex-1 flex flex-col overflow-hidden bg-background">
        <Header 
          title={translateInterfaceText("Indique e Ganhe")}
          subtitle={translateInterfaceText("Ganhe de forma recorrente indicando a plataforma nº1 de VSLs do Brasil")}
        />
        
        <div className="hidden lg:block h-px bg-border w-full" />
        
        <main className="flex-1 overflow-y-auto scrollbar-blue">
          <div className="max-w-6xl mx-auto p-4 md:p-6 space-y-12">
            <ReferralHero />
            <ReferralBenefits />
            <ReferralSteps />
            <ReferralAudience />
            <ReferralSimulator />
            <ReferralFAQ />
            <ReferralCTA />
          </div>
        </main>
      </div>
    </Layout>
  );
}
